import { render, staticRenderFns } from "./UnavailableLabel.vue?vue&type=template&id=3ddcf68c&scoped=true"
import script from "./UnavailableLabel.vue?vue&type=script&lang=ts"
export * from "./UnavailableLabel.vue?vue&type=script&lang=ts"
import style0 from "./UnavailableLabel.vue?vue&type=style&index=0&id=3ddcf68c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_440794991c458c99f4ea4042de23b4db/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddcf68c",
  null
  
)

export default component.exports